import type {DropdownIndicatorProps, GroupBase} from "react-select";
import {components} from "react-select";

import {ChevronDownIcon} from "../../react/components/Icons/ChevronDownIcon";

import type {OptionType} from "./Select";

export function DropdownIndicator<
    Option extends OptionType,
    IsMulti extends boolean,
    Group extends GroupBase<Option>
>(props: DropdownIndicatorProps<Option, IsMulti, Group>) {
    return (
        <components.DropdownIndicator {...props}>
            <ChevronDownIcon fill="blueGray.400" size="sm" />
        </components.DropdownIndicator>
    );
}
